import styled from 'styled-components';
import { Form } from '@sketch/components';

const StyledForm = styled(Form) `
  margin-top: 24px;
`;

export { StyledForm };
